customElements.define('product-selector', class extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.selectd_variant = this.querySelector('.selected-variant');
		this.option_items = this.querySelectorAll('.option-item');
		this.variant_json = document.querySelectorAll('.json-item');

		this.control_items = this.querySelectorAll('.control-item');
		this.options = this.querySelectorAll('.option-item');

		this.control_items.forEach(e=>{
			e.addEventListener('click' , ()=>{
				this.selectd_variant.innerHTML = e.dataset.title;
				var current_title = e.dataset.title;
				this.control_items.forEach(e=>e.classList.remove('active'));
				e.classList.add('active');

				const control_prices = document.querySelectorAll('.control-item-price.variable-price')

				for (const price of control_prices) {
					let new_price = price.getAttribute('data-price_1');
					if ( e.dataset.item == 'beach-towels-individual') {
						//change to towel bundle pricing
						new_price = price.getAttribute('data-price_2');
					}
					price.innerHTML = new_price
				}

				this.options.forEach(ele=>{
					if (ele.dataset.item == e.dataset.item) {
						ele.classList.remove('none')
						const option_selected = ele.querySelector('input:checked');
						if ( option_selected == null ) {
							const first_opt = ele.querySelector('.option-value input')
							first_opt.click()
						}
					}
					else  ele.classList.add('none')
				})

			})
		})

		this.option_items.forEach(e=>{
			const optionValues = e.querySelectorAll('.option-value-label:not(.disabled)');

			optionValues.forEach((label) => {
				label.addEventListener('click',()=>{

					let input = label.previousElementSibling;
					const new_option = input.dataset.colour;
					let new_title = e.closest('.products-wrapper').previousElementSibling.querySelector('.selected-variant');
					const current_title = new_title.innerHTML.split('-')[0];
					new_title.innerHTML = `${current_title} - ${new_option}`;

					const swatchImage = label.querySelector('img');
					if (!swatchImage) return;
					const new_img = swatchImage.getAttribute('data-feature');
					const feautre_img = document.getElementById('bundle-builder-feature')

					feautre_img.src = new_img;

				})
			})

		})
	}

	attributeChangedCallback() {
		console.log('Custom square element attributes changed.');
	}
});
